import { useCredentialingTranslation } from '../../../../../ui/hooks';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import React, { useCallback, useEffect, useState } from 'react';
export const PersonSubtitle = ({ county, tribeId, residenceType }) => {
    const { t } = useCredentialingTranslation();
    const [subtitle, setSubtitle] = useState('');
    const tribeStorage = useStorageClient('tribe');
    const fetchTribe = useCallback(() => {
        if (!tribeId) {
            return;
        }
        setSubtitle(t('common.loading'));
        tribeStorage
            .get(tribeId)
            .then((response) => {
            setSubtitle(response.columns.name);
        })
            .catch(() => {
            setSubtitle(t('common.unknownError'));
        });
    }, [tribeStorage, tribeId, t]);
    useEffect(() => {
        if (residenceType === 'county' && county) {
            setSubtitle(county);
        }
        if (residenceType === 'tribe') {
            fetchTribe();
        }
    }, [county, tribeId, residenceType, fetchTribe]);
    if (!residenceType) {
        return null;
    }
    return React.createElement(React.Fragment, null, subtitle);
};
